import { render, staticRenderFns } from "./pcTips.vue?vue&type=template&id=814ac166&scoped=true"
import script from "./pcTips.vue?vue&type=script&lang=js"
export * from "./pcTips.vue?vue&type=script&lang=js"
import style0 from "./pcTips.vue?vue&type=style&index=0&id=814ac166&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814ac166",
  null
  
)

export default component.exports